export default {
  getNotification: (state) => state.notification,
};
